import(/* webpackMode: "eager" */ "/vercel/path0/src/app/portfolio/page.tsx");
